import { Component, Fragment } from 'react';
import styled from 'styled-components';
import { IconCommentRegular } from '@yj-intl/riff-react/icon-v2';
import { fontSize } from '../../../../../common/css/setting/variable';

interface IProps {
  commentCount: number;
}

const CommentCount = styled.span`
  font-size: ${fontSize.px12};
  line-height: ${fontSize.px18};
  color: ${props => props.theme.news.palette.text_sub_lv1_common};
`;

const StyledIconComment = styled(IconCommentRegular)`
  margin-left: 8px;
  vertical-align: bottom;
`;

export default class NewsFeedCommentCount extends Component<IProps> {
  /**
   *
   */
  public render() {
    // コメント件数が表示トルツメの足切り数値に満たない場合,トルツメ表示
    if (this.props.commentCount <= 0) {
      return null;
    }

    return (
      <Fragment>
        <StyledIconComment size={18} />
        <CommentCount>{this.props.commentCount}</CommentCount>
      </Fragment>
    );
  }
}
